import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { OrderFragments } from '../../graphql/order.graphql';
import { Order } from '../../types/order/order';
import { useAppDispatch } from '../../ui/pages/store';
import { orderSlice } from '../../providers/OrderProvider';

const orderSubscription = gql`
  subscription orderNotification($companyId: String!) {
    orderNotification(companyId: $companyId) {
      companyId
      entities {
        ...Order
      }
      topic
      date
    }
  }
  ${OrderFragments.order}
`;

export class OrderNotificationResponse extends forNotification<Order>('orderNotification') {}

export default function OrderNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: orderNotification } = useSubscription<OrderNotificationResponse>(orderSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleOrderNotification = (notification?: OrderNotificationResponse) => {
    if (!notification?.orderNotification) return;
    const orderNotification = notification.orderNotification;

    switch (orderNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(orderSlice.actions.add(orderNotification.entities));
        break;
      case 'DELETE':
        dispatch(orderSlice.actions.delete(orderNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleOrderNotification(orderNotification);
  }, [orderNotification]);

  return <></>;
}
